export default "__VITE_ASSET__aaa2f9d3__"